module.exports = __webpack_public_path__ + "img/2.01.thmb.xs.4d04cfdb.jpg";